<template>
  <VaccinationPage
    title="50 years and above"
    :buttons="buttons"
    baseRoute="/oldPeopleSecondPage"
    :bottomImage="require('@/assets/page8/Asset 50.png')"
    :footerBanner="require('@/assets/page4/lowererPanner.png')"
    prevRoute="/vaccination"
    nextRoute="/oldPeopleSecondPage"
  />
</template>

<script setup>
import VaccinationPage from "@/components/VaccinationPage.vue";

const buttons = [
  { imgPath: require("@/assets/page8/Asset 36.png"), name: "Influenza" },
  { imgPath: require("@/assets/page8/Asset 37.png"), name: "Pneumococcal" },
  { imgPath: require("@/assets/page8/Asset 38.png"), name: "RSV" },
  { imgPath: require("@/assets/page8/Asset 39.png"), name: "Zoster" },
  { imgPath: require("@/assets/page8/Asset 40.png"), name: "OldPeople" , disabled: true},
  { imgPath: require("@/assets/page8/Asset 41.png"), name: "COVID-19" },
  { imgPath: require("@/assets/page8/Asset 42.png"), name: "MMR" },
  { imgPath: require("@/assets/page8/Asset 43.png"), name: "Varicella" },
  { imgPath: require("@/assets/page8/Asset 44.png"), name: "Tetanus" },
  { imgPath: require("@/assets/page8/Asset 46.png"), name: "HepatitisA" },
  { imgPath: require("@/assets/page8/Asset 47.png"), name: "HepatitisB" },
  { imgPath: require("@/assets/page8/Asset 40.png"), name: "OldPeople", disabled: true },
];
</script>
